module.exports = __webpack_public_path__ + "static/media/slider3.207b1f66.jpg";